import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'

import { useTexts } from '../../useTexts'
import { useDeleteOrders } from './useDeleteOrders'

export function DeleteOrders() {
  const { confirmations, handleCheckboxChange } = useDeleteOrders()
  const texts = useTexts()

  return (
    <Stack spacing={3}>
      <Typography variant="body2" color="text.secondary">
        {texts.deleteDescription}
      </Typography>

      <Stack spacing={2}>
        <FormControlLabel
          control={
            <Checkbox
              checked={confirmations.deleteOrders}
              onChange={(_, checked) => handleCheckboxChange('deleteOrders')(checked)}
            />
          }
          label={texts.deleteCheckOne}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={confirmations.revokeRoutes}
              onChange={(_, checked) => handleCheckboxChange('revokeRoutes')(checked)}
            />
          }
          label={texts.deleteCheckTwo}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={confirmations.undoWarning}
              onChange={(_, checked) => handleCheckboxChange('undoWarning')(checked)}
            />
          }
          label={texts.deleteCheckThree}
        />
      </Stack>
    </Stack>
  )
}
